import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { User } from '@rocksoft/security-sdk';
import { ErrorModel } from '@rocksoft/shared';

// ============================================================================
// RESOLVER ACTIONS (Group - using createActionGroup)
// ============================================================================

export const UserResolverActions = createActionGroup({
  source: 'User Resolver',
  events: {
    'Suggested Users requested': emptyProps(),
  },
});

// ============================================================================
// API ACTIONS (Group - using createActionGroup)
// ============================================================================

export const SuggestedUserApiActions = createActionGroup({
  source: 'Suggested User API',
  events: {
    'Suggested Users loaded': props<{ suggestedUsers: User[] }>(),
    'Error loading Suggested Users': props<{ error: ErrorModel }>(),
  },
});
